module.exports = __webpack_public_path__ + "img/search.58385d92.svg";